import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { PyramidhomeComponent,FeedBackLoops,ContractMods,MELProducts, Monitoring, PortfolioReviews,
  ActivityDesign,ActivityWorkplanRevisions, AfterActionReviews,AllStaffMeeting,InformalLearning,
  IPMeetings, LearningEvents,MissionLeadership,ProjectDesign, Retreats,SeniorManTeam, SysMap,
   DecisionTree, ImplementationLetter,LearningAgenda, LearningNetwork, ODAssessment,
   ProjectImplementation,StakeholderEngagement,WhatsThis} from './pages/pyramidhome/pyramidhome.component';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from './shared/footer/footer.component';
@NgModule({
  declarations: [
    AppComponent,
    PyramidhomeComponent,
    FeedBackLoops,ContractMods,MELProducts,Monitoring,PortfolioReviews,
    ActivityDesign,ActivityWorkplanRevisions,AfterActionReviews,AllStaffMeeting,
    InformalLearning,IPMeetings,LearningEvents,MissionLeadership,ProjectDesign,
    Retreats,SeniorManTeam,SysMap,DecisionTree,ImplementationLetter,LearningAgenda,
    LearningNetwork,ODAssessment,ProjectImplementation,WhatsThis,
    StakeholderEngagement,
    HeaderComponent,
    FooterComponent
  ],
  entryComponents: [PyramidhomeComponent,FeedBackLoops,ContractMods,MELProducts,Monitoring,PortfolioReviews,
    ActivityDesign,ActivityWorkplanRevisions,AfterActionReviews,AllStaffMeeting,InformalLearning,
    IPMeetings,LearningEvents,MissionLeadership,ProjectDesign,Retreats,SeniorManTeam,
    SysMap,DecisionTree,ImplementationLetter, LearningAgenda,LearningNetwork,
    ODAssessment,ProjectImplementation,StakeholderEngagement,WhatsThis],
  imports: [
    BrowserModule,
    MatDialogModule ,
    BrowserAnimationsModule,
    MatTabsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
